import graph from "./graph";
import schema from "./schema";
import uiSchema from "./uiSchema";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useLazyQuery, useMutation } from "@apollo/client";
import { cleanData, isEmptyObject } from "helpers/formatObject";
import {
  Stack,
  Button,
  Typography,
  IconButton,
  CircularProgress,
} from "@mui/material";

import {
  NewDialog,
  MuiFormBuilder,
  NewDialogTitle,
  NewDialogContent,
  NewDialogActions,
} from "components";
import { ModeEditRounded } from "@mui/icons-material";

export default function Update({
  id,
  title = "ویرایش",
  onUpdate,
  onRemove,
  onLoading,
}) {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const { userToken } = useSelector((state) => state.auth);
  const [fetchModel, { loading }] = useLazyQuery(graph.get.query);
  const [update, { loading: updating }] = useMutation(graph.update.query);

  const onOpen = () => setOpen(true);
  const onClose = () => setOpen(false);

  const getModel = async () => {
    try {
      const { data } = await fetchModel({
        context: {
          serviceName: graph.get.serviceName,
          headers: {
            authorization: `Bearer ${userToken}`,
          },
        },
        variables: {
          ids: id,
          for_admin: 1,
        },
      });
      if (!isEmptyObject(data)) {
        const res = data[graph.get.name].data[0];
        const {
          email,
          gender,
          is_active,
          lastname,
          firstname,
          birth_date,
          national_code,
        } = res;
        if (res) {
          setFormData(
            cleanData({
              email,
              lastname,
              firstname,
              birth_date,
              national_code,
              gender: Number(gender),
              is_active: Number(is_active),
            })
          );
        }
      }
    } catch (error) {}
  };

  const onSubmit = async ({ formData }) => {
    try {
      onClose();
      onLoading(true);
      const { data, errors } = await update({
        context: {
          serviceName: graph.update.serviceName,
          headers: {
            authorization: `Bearer ${userToken}`,
          },
        },
        variables: {
          ids: id,
          ...formData,
        },
      });
      if (!errors) {
        onLoading(false);
        if (!isEmptyObject(data)) {
          const { messages, model } = data[graph.update.name];
          onUpdate(model);
          messages.map((message) => toast.success(String(message)));
        }
      }
    } catch (error) {
      onOpen();
      onLoading(false);
      setFormData(formData);
    }
  };

  useEffect(() => {
    open && getModel();
  }, [open]);

  return (
    <>
      <IconButton
        size="small"
        color="info"
        onClick={onOpen}
        sx={{ bgcolor: "action.hover" }}
      >
        <ModeEditRounded fontSize="small" />
      </IconButton>
      <NewDialog open={open} onClose={onClose}>
        <NewDialogTitle title={title} onClose={onClose} />
        <NewDialogContent isPopup>
          <Stack p={1} flex={1} rowGap={1} bgcolor="background.paper">
            {loading ? (
              <Stack
                rowGap={2}
                height="100%"
                alignItems="center"
                justifyContent="center"
              >
                <CircularProgress size={20} color="inherit" />
                <Typography
                  align="center"
                  variant="caption"
                  color="text.disabled"
                >
                  در حال بارگذاری...
                </Typography>
              </Stack>
            ) : (
              <MuiFormBuilder
                id="update"
                showSubmit={false}
                liveValidate={false}
                schema={schema()}
                uiSchema={uiSchema()}
                formData={formData}
                onSubmit={onSubmit}
              />
            )}
          </Stack>
        </NewDialogContent>
        <NewDialogActions>
          <Button
            autoFocus
            fullWidth
            size="large"
            type="submit"
            form="update"
            variant="contained"
            disabled={loading || updating}
          >
            ویرایش
          </Button>
        </NewDialogActions>
      </NewDialog>
    </>
  );
}
